import AssistantChat from '@/components/section/assistant-chat/assistantChat';

const AssistantChatPage = () => {
  return <AssistantChat />;
};

export default AssistantChatPage;
